import { Dropzone } from "../dropzone";
import { useNetworkContext } from "../../../network";
import { InputHeightProvider, DropzoneProvider } from "../../contexts";
import { ChatCreateError, ChatNotInit, ChatUnavailable } from "../banners";
import { ChatInput } from "../chat-input";
import { ChatMessageList } from "../chat-message-list";

export const ChatBody = () => {
  const {
    isAuthError,
    isChatConnectError,
    isPostChatInfoLoading,
    isPostChatInfoError,
  } = useNetworkContext();

  const shouldShownChatCreateErrorBanner =
    !isChatConnectError && isPostChatInfoError;

  if (isAuthError || isChatConnectError) {
    return <ChatUnavailable />;
  }

  if (shouldShownChatCreateErrorBanner) {
    return <ChatCreateError />;
  }

  if (isPostChatInfoLoading) {
    return <ChatNotInit />;
  }

  return (
    <InputHeightProvider>
      <DropzoneProvider>
        <Dropzone>
          <ChatMessageList />
        </Dropzone>
        <ChatInput />
      </DropzoneProvider>
    </InputHeightProvider>
  );
};
